import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CpaasClient, CPAAS_CLIENTS } from './cdr-clients.constants';

@Injectable({ providedIn: 'root' })
export class CpaasClientsService {
  /**
   * Returns the list of enterprise CPaaS clients.
   *
   * When the API endpoint is available, replace the body of this method with:
   *   return this.http.get<CpaasClient[]>('<ENDPOINT_URL>');
   * and inject HttpClient.
   */
  getClients(): Observable<CpaasClient[]> {
    return of(CPAAS_CLIENTS);
  }
}
